<template>
  <div class="view">
    <h1 class="ui header">Error 404</h1>
  </div>
</template>

<script>
  export default {
    name: 'Error404',
  }
</script>

<style scoped>
  .view { display: flex; align-items: center; justify-content: center; }
</style>
